import script from "./ElaComputerPatchingLogs.vue?vue&type=script&setup=true&lang=js"
export * from "./ElaComputerPatchingLogs.vue?vue&type=script&setup=true&lang=js"

import "./ElaComputerPatchingLogs.vue?vue&type=style&index=0&id=790771b4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ELA/ELA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-790771b4"]])

export default __exports__